import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Manager, Target, Popper } from "react-popper";

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import MenuItem from "material-ui/Menu/MenuItem";
import MenuList from "material-ui/Menu/MenuList";
import ClickAwayListener from "material-ui/utils/ClickAwayListener";
import Paper from "material-ui/Paper";
import Grow from "material-ui/transitions/Grow";
import IconButton from "material-ui/IconButton";
import Hidden from "material-ui/Hidden";

// @material-ui/icons
// import Person from "@material-ui/icons/Person";
// import Notifications from "@material-ui/icons/Notifications";
// import LanguageIcon from '@material-ui/icons/Language';
// import Dashboard from "@material-ui/icons/Dashboard";
// import Search from "@material-ui/icons/Search";

// core components
// import CustomInput from "../../components/CustomInput/CustomInput.jsx";
// import SearchButton from "../../components/CustomButtons/IconButton.jsx";

import headerLinksStyle from "../../assets/jss/material-dashboard-pro-react/components/headerLinksStyle";

import itFlag from "../../assets/img/flags/IT.png";
import gbFlag from "../../assets/img/flags/GB.png";
import frFlag from "../../assets/img/flags/FR.png";
import deFlag from "../../assets/img/flags/DE.png";
import esFlag from "../../assets/img/flags/ES.png";
import {inject, observer} from "mobx-react";
import {toJS} from "mobx";
// import Select from "material-ui/Select/Select";


@inject('store')
@observer
class HeaderLinks extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            language: ''
        };

        this.store = this.props.store.appState;
    }


    handleClick = () => {
        // console.log("handle click");
        this.setState({ open: !this.state.open });
    };

    onLanguageChange = (lang) => (event) => {
        // console.log(lang);
        this.setState({language: lang});
        this.store.handle_app_lang(lang);

        // const DEFAULT_TEXT = import(`../../assets/translations/${lang}`).then((lang) => {
        import(`../../assets/translations/${lang}`).then((lang) => {
            this.setState({
                text: lang
            })
        }).catch((error) => {
            console.log('translation not yet supported ',error);
            console.error(`"${this.state.language}" not yet supported`);
        });
    };

    handleClose = () => {
        // console.log("handle close");
        this.setState({ open: false });
    };



  render() {
    const { classes, rtlActive } = this.props;
    const { open } = this.state;

    /*
    const searchButton =
      classes.top +
      " " +
      classes.searchButton +
      " " +
      classNames({
        [classes.searchRTL]: rtlActive
      });
    */

    /*
    const dropdownItem =
      classes.dropdownItem +
      " " +
      classNames({
        [classes.dropdownItemRTL]: rtlActive
      });
    */

    const wrapper = classNames({
      [classes.wrapperRTL]: rtlActive
    });

    const managerClasses = classNames({
      [classes.managerClasses]: true
    });

   const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);

    return (
      <div className={wrapper}>
            <Manager className={managerClasses}>
              <Target>
                <IconButton
                  color="inherit"
                  aria-label="Language"
                  aria-owns={open ? "menu-list" : null}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  className={rtlActive ? classes.buttonLinkRTL:classes.buttonLink}
                  classes={{
                    label: rtlActive ? classes.labelRTL:""
                  }}
                >
                  {/*<LanguageIcon className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} />*/}

                    {(() => {
                        // console.log(this.store.lang);
                        switch (this.store.lang) {
                            case "it":  return <span className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} style={{marginBottom: "10px"}}><img src={itFlag} alt="..."/></span>;
                            case "fr":  return <span className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} style={{marginBottom: "10px"}} ><img src={frFlag} alt="..."/></span>;
                            case "de":  return <span className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} style={{marginBottom: "10px"}} ><img src={deFlag} alt="..."/></span>;
                            case "es":  return <span className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} style={{marginBottom: "10px"}} ><img src={esFlag} alt="..."/></span>;
                            // case "en":  return <span className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} style={{marginBottom: "10px"}} ><img src={gbFlag} alt="..."/></span>;
                            case "en":
                            default:  return <span className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} style={{marginBottom: "10px"}} ><img src={gbFlag} alt="..."/></span>;
                        }
                    })()}

                  {/*<span className={classes.notifications}>5</span>*/}
                  <Hidden mdUp>
                    <p onClick={this.handleClick} className={classes.linkText}>
                      {rtlActive ? "إعلام" : DEFAULT_TEXT.language}
                    </p>
                  </Hidden>
                </IconButton>
              </Target>
              <Popper
                placement="bottom-start"
                eventsEnabled={open}
                className={
                  classNames({ [classes.popperClose]: !open }) +
                  " " +
                  classes.pooperResponsive
                }
              >
                <ClickAwayListener onClickAway={this.handleClose}>
                  <Grow
                    in={open}
                    id="menu-list"
                    style={{ transformOrigin: "0 0 0" }}
                  >
                    <Paper>
                      <MenuList role="menu">

                          <MenuItem onClick={this.onLanguageChange('it')}>
                              <span><img src={itFlag} alt="..."/></span>
                          </MenuItem>

                          <MenuItem onClick={this.onLanguageChange('en')}>
                              <span><img src={gbFlag} alt="..."/></span>
                          </MenuItem>

                          <MenuItem onClick={this.onLanguageChange('fr')}>
                              <span><img src={frFlag} alt="..."/></span>
                          </MenuItem>

                          <MenuItem onClick={this.onLanguageChange('de')}>
                              <span><img src={deFlag} alt="..."/></span>
                          </MenuItem>

                          <MenuItem onClick={this.onLanguageChange('es')}>
                              <span><img src={esFlag} alt="..."/></span>
                          </MenuItem>
                      </MenuList>
                    </Paper>
                  </Grow>
                </ClickAwayListener>
              </Popper>
            </Manager>

          {/*<IconButton*/}
          {/*    color="inherit"*/}
          {/*    aria-label="Person"*/}
          {/*    className={rtlActive ? classes.buttonLinkRTL:classes.buttonLink}*/}
          {/*    classes={{*/}
          {/*        label: rtlActive ? classes.labelRTL:""*/}
          {/*    }}*/}
          {/*>*/}
          {/*    <Person className={rtlActive ? classes.links + " " + classes.linksRTL:classes.links} />*/}
          {/*    <Hidden mdUp>*/}
          {/*        <p className={classes.linkText}>*/}
          {/*            {rtlActive ? "الملف الشخصي" : "Nome Merchant"}*/}
          {/*        </p>*/}
          {/*    </Hidden>*/}
          {/*</IconButton>*/}
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
  rtlActive: PropTypes.bool
};

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx